import React from 'react';
import { SVGAttributes } from 'react';

export const MedicalReportIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
    >
      <path
        d="M7.66667 16H1.83333C1.61232 16 1.40036 15.9122 1.24408 15.7559C1.0878 15.5996 1 15.3877 1 15.1667V1.83333C1 1.61232 1.0878 1.40036 1.24408 1.24408C1.40036 1.0878 1.61232 1 1.83333 1H13.5C13.721 1 13.933 1.0878 14.0893 1.24408C14.2455 1.40036 14.3333 1.61232 14.3333 1.83333V6.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3483 9.75004C14.3525 9.75004 15.1667 10.5334 15.1667 11.5C15.1667 12.7584 13.9542 13.8334 13.3483 14.4167C12.9442 14.8055 12.4396 15.1946 11.8333 15.5834C11.2275 15.1946 10.7221 14.8055 10.3183 14.4167C9.71208 13.8334 8.5 12.7584 8.5 11.5C8.5 10.5334 9.31417 9.75004 10.3183 9.75004C10.9504 9.75004 11.5075 10.0609 11.8333 10.5325C12.0037 10.2893 12.2306 10.091 12.4945 9.95472C12.7583 9.81843 13.0513 9.74819 13.3483 9.75004Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M4.33301 4.33398H10.9997"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default MedicalReportIcon;
